module.exports = __webpack_public_path__ + "static/img/ku-csp.7f4bbc4.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing-detail/ku-csp.jpg
// module id = IlJb
// module chunks = 0